import { useEffect, useState } from 'react';
export const useOverflowNavigation = _ref => {
  let {
    openSubMenu,
    setOpenSubMenu,
    menuButton,
    profileButton,
    wrapperRef
  } = _ref;
  const [focusedItem, setFocusedItem] = useState(-1);
  useEffect(() => {
    const handleNavigation = event => {
      var _a;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowUp' && event.key !== 'Tab' && event.key !== 'Escape' && event.shiftKey) {
        return;
      }
      if (!openSubMenu) {
        return setFocusedItem(-1);
      }
      const isTablet = window.innerWidth < 840;
      if (event.key === 'Escape') {
        setOpenSubMenu(false);
        return isTablet ? menuButton === null || menuButton === void 0 ? void 0 : menuButton.focus() : profileButton === null || profileButton === void 0 ? void 0 : profileButton.focus();
      }
      const elementsToNavigate = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a[href]');
      if (event.key === 'ArrowDown' || !event.shiftKey && event.key === 'Tab') {
        if (focusedItem === -1) {
          event.preventDefault();
          elementsToNavigate.item(0).focus();
          return setFocusedItem(0);
        }
      }
      elementsToNavigate.forEach((element, index) => {
        if (element !== event.target) {
          return;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          const nextElement = elementsToNavigate[index + 1];
          return nextElement ? nextElement.focus() : null;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          const previousElement = elementsToNavigate[index - 1];
          return previousElement ? previousElement.focus() : null;
        }
        if (!event.shiftKey && event.key === 'Tab' && index === elementsToNavigate.length - 1 && isTablet) {
          event.preventDefault();
          const nextElement = menuButton === null || menuButton === void 0 ? void 0 : menuButton.nextElementSibling;
          nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
          return setOpenSubMenu(false);
        }
        if (event.shiftKey && event.key === 'Tab' && index === 0 && isTablet) {
          event.preventDefault();
          menuButton === null || menuButton === void 0 ? void 0 : menuButton.focus();
          return setOpenSubMenu(false);
        }
      });
    };
    window.addEventListener('keydown', handleNavigation);
    return () => {
      window.removeEventListener('keydown', handleNavigation);
    };
  }, [focusedItem, menuButton, openSubMenu, profileButton, setOpenSubMenu, wrapperRef]);
};